export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/2cb37da391587709fd85749e116baa74.svg";